module.exports = __webpack_public_path__ + "img/next.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/img/next.png
// module id = 373
// module chunks = 0